import { render, staticRenderFns } from "./FormStatoPatrimoniale.vue?vue&type=template&id=226047a3&"
import script from "./FormStatoPatrimoniale.vue?vue&type=script&lang=js&"
export * from "./FormStatoPatrimoniale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports